import {createContext, useContext, ReactNode} from 'react';

import useMoneyCards from '~/shared/hooks/useMoneyCards';
import {ApiError} from '~/shared/services/apiErrorService';
import {api} from '~/shared/services/bffService';

interface PersonalAreaContextValue {
  tenbisCreditBalance: number;
  isMoneyCardsLoaded: boolean;
  isMoneyCardsLoading: boolean;
  refetchMoneyCards: () => void;
  moneyCardsError?: ApiError;
}

const PersonalAreaContext = createContext<PersonalAreaContextValue | undefined>(undefined);

export const usePersonalAreaContext = () => {
  const context = useContext(PersonalAreaContext);
  if (!context) {
    throw new Error('usePersonalAreaContext must be used within PersonalAreaProvider');
  }
  return context;
};

interface PersonalAreaProviderProps {
  children: ReactNode;
}

export const PersonalAreaProvider = ({children}: PersonalAreaProviderProps) => {
  const {
    tenbisCreditBalance,
    loaded: isMoneyCardsLoaded,
    loading: isMoneyCardsLoading,
    refetch: refetchMoneyCards,
    error: moneyCardsError,
  } = useMoneyCards({
    fetchMoneyCards: api.fetchMoneycards,
  });

  const value: PersonalAreaContextValue = {
    tenbisCreditBalance,
    isMoneyCardsLoaded,
    isMoneyCardsLoading,
    refetchMoneyCards,
    moneyCardsError,
  };

  return (
    <PersonalAreaContext.Provider value={value}>
      {children}
    </PersonalAreaContext.Provider>
  );
};
